// httpClientIntegration defaults to capturing failed requests to every host,
// which reports 4xx from third parties we don't own (Cognito, widgets,
// analytics) alongside our own. Restrict it to the backends we can act on.
//
// Hosts follow `<service>.api.makesuccess.io` in prod and
// `<service>.mobsuccess.dev.api.makesuccess.io` elsewhere — see
// backend/amplify/middleware.ts. Requests also reach API Gateway directly
// through the blocked-domain fallback and PR stacks, whose ids are unstable.
export const FIRST_PARTY_REQUEST_TARGETS = [
  /\.api\.makesuccess\.io/,
  /\.execute-api\.[a-z0-9-]+\.amazonaws\.com/,
  /\.appsync(-realtime)?-api\.[a-z0-9-]+\.amazonaws\.com/,
  /\.amplifyapp\.com/,
  /mobtranslate\.mobsuccess\.ai/,
  /\bwww\.farly\.io/,
  /\.mobsuccess\.com/,
  // the php backend is served same-origin, so axios sends a relative url
  /^\/(api|app-api)\b/,
];
